
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import { Box, Card, CardContent, Typography, CircularProgress } from "@mui/material";
import { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";
import "../css/wb_manage_block_number.css";
import { useParams } from "react-router-dom";
import { getPaymentStatusFromAPI } from "../services/paymentStatus";

function PaymentStatus() {
    const navigate = useNavigate()
    const { id } = useParams()
    console.log(id)
    const [status, setStatus] = useState("Pending");
    // 'Completed', 'Failed', 'Pending'

    const [paymentDetails, setPaymentDetails] = useState({
        transactionID: "WAL-1234567890",
        amount: 1000,
        method: "NET_BANKING",
        status: "Pending",
        transactionAt: "01-12-2025 04:13:11"
    });

    useEffect(() => {
        const fetchPaymentStatus = async () => {

            try {
                const response = await getPaymentStatusFromAPI(id);
                setStatus(response.status);
                setPaymentDetails(response);
            } catch (error) {
                console.log("Error fetching payment status:", error);
            }

        };

        fetchPaymentStatus();

        const interval = setInterval(() => {
            fetchPaymentStatus();
        }, 2000);

        return () => clearInterval(interval);
    }, []);



    const getStatusConfig = () => {
        switch (status) {
            case "Completed":
                return {
                    icon: <CheckCircleIcon sx={{ fontSize: 80, color: "#434343" }} />,
                    title: "Payment Successful",
                    color: "#434343",
                    bgColor: "#f0f0f0",
                    chipColor: "success"
                };
            case "Failed":
                return {
                    icon: <CancelIcon sx={{ fontSize: 80, color: "#de1717" }} />,
                    title: "Payment Failed",
                    color: "#de1717",
                    bgColor: "#fff0f0",
                    chipColor: "error"
                };
            case "Pending":
                return {
                    icon: (
                        <Box sx={{ position: "relative", display: "inline-flex" }}>
                            <CircularProgress
                                size={80}
                                thickness={2}
                                sx={{ color: "#ff9800" }}
                            />
                            <Box
                                sx={{
                                    top: 0,
                                    left: 0,
                                    bottom: 0,
                                    right: 0,
                                    position: "absolute",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                            >
                                <HourglassEmptyIcon sx={{ fontSize: 40, color: "#ff9800" }} />
                            </Box>
                        </Box>
                    ),
                    title: "Payment Processing",
                    color: "#ff9800",
                    bgColor: "#fcf7efff",
                    chipColor: "warning"
                };
            default:
                return {
                    icon: <HourglassEmptyIcon sx={{ fontSize: 80, color: "#9e9e9e" }} />,
                    title: "Unknown Status",
                    color: "#9e9e9e",
                    bgColor: "#f5f5f5",
                    chipColor: "default"
                };
        }
    };

    const config = getStatusConfig();

    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "100dvh",
                backgroundColor: "#f5f5f5",
                padding: 2
            }}
        >
            <Card
                sx={{
                    maxWidth: 450,
                    width: "100%",
                    boxShadow: 3,
                    borderRadius: 2,
                    overflow: "hidden"
                }}
            >
                <Box
                    sx={{
                        backgroundColor: config.bgColor,
                        padding: 4,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: 2
                    }}
                >
                    {config.icon}
                    <Typography
                        variant="h5"
                        sx={{
                            fontWeight: 600,
                            color: config.color,
                            textAlign: "center"
                        }}
                    >
                        {config.title}
                    </Typography>
                    {/* <Chip
                        label={status.toUpperCase()}
                        color={config.chipColor}
                        size="small"
                        sx={{ fontWeight: 600 }}
                    /> */}
                </Box>

                <CardContent sx={{ padding: 3 }}>
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                            <Typography variant="body2" color="text.secondary">
                                Transaction ID:
                            </Typography>
                            <Typography variant="body2" fontWeight={600}>
                                {paymentDetails.transactionID}
                            </Typography>
                        </Box>

                        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                            <Typography variant="body2" color="text.secondary">
                                Amount:
                            </Typography>
                            <Typography variant="body2" fontWeight={600}>
                                ₹{paymentDetails.amount.toLocaleString()}
                            </Typography>
                        </Box>

                        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                            <Typography variant="body2" color="text.secondary">
                                Payment Method:
                            </Typography>
                            <Typography variant="body2" fontWeight={600}>
                                {paymentDetails.method}
                            </Typography>
                        </Box>

                        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                            <Typography variant="body2" color="text.secondary">
                                Payment Status:
                            </Typography>
                            <Typography variant="body2" fontWeight={600}>
                                {paymentDetails.status}
                            </Typography>
                        </Box>

                        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                            <Typography variant="body2" color="text.secondary">
                                Date & Time:
                            </Typography>
                            <Typography variant="body2" fontWeight={600}>
                                {paymentDetails.transactionAt}
                            </Typography>
                        </Box>
                    </Box>

                    {status === "Pending" && (
                        <Box sx={{ mt: 3, textAlign: "center" }}>
                            <Typography variant="body2" color="text.secondary" sx={{ fontStyle: "italic" }}>
                                Please wait while we process your payment...
                            </Typography>
                        </Box>
                    )}

                    {status !== "Pending" && (
                        <Box sx={{ mt: 3, display: "flex", gap: 2 }}>
                            <button
                                className="Button_contain"
                                style={{ flex: 1 }}
                                onClick={() => navigate('/')}

                            >
                                Go to Dashboard
                            </button>

                        </Box>
                    )}
                </CardContent>
            </Card>
        </Box>
    );
}

export default PaymentStatus;